import React from "react";
import { Table } from "../../../../ui/components/Table";
import { Button } from "../../../../ui/components/Button";
import { Badge } from "../../../../ui/components/Badge";
import { FeatherEdit, FeatherTrash2 } from "@subframe/core";
import { UserEntity } from "../../domain/entities/UserEntity";

interface UserListTableProps {
  users: UserEntity[];
  onEdit?: (user: UserEntity) => void;
  onDelete?: (userId: number) => void;
  loading?: boolean;
}

export const UserListTable: React.FC<UserListTableProps> = ({
  users,
  onEdit,
  onDelete,
  loading = false,
}) => {
  return (
    <Table
      header={
        <Table.HeaderRow>
          <Table.HeaderCell>Username</Table.HeaderCell>
          <Table.HeaderCell>Email</Table.HeaderCell>
          <Table.HeaderCell>Role</Table.HeaderCell>
          <Table.HeaderCell>Manager</Table.HeaderCell>
          <Table.HeaderCell>Created</Table.HeaderCell>
          <Table.HeaderCell>Actions</Table.HeaderCell>
        </Table.HeaderRow>
      }
    >
      {loading && users.length === 0 ? (
        <Table.Row>
          <Table.Cell colSpan={6} className="text-center py-8">
            <span className="text-body font-body text-subtext-color">
              Loading users...
            </span>
          </Table.Cell>
        </Table.Row>
      ) : users.length === 0 ? (
        <Table.Row>
          <Table.Cell colSpan={6} className="text-center py-8">
            <span className="text-body font-body text-subtext-color">
              No users found
            </span>
          </Table.Cell>
        </Table.Row>
      ) : (
        users.map((user) => (
          <Table.Row key={user.id}>
            <Table.Cell>
              <span className="text-body font-body text-default-font">
                {user.userName || "N/A"}
              </span>
            </Table.Cell>
            <Table.Cell>
              <span className="text-body font-body text-default-font">
                {user.email}
              </span>
            </Table.Cell>
            <Table.Cell>
              <Badge variant="neutral">{user.role}</Badge>
            </Table.Cell>
            <Table.Cell>
              <span className="text-body font-body text-subtext-color">
                {user.manager_name || "No Manager"}
              </span>
            </Table.Cell>
            <Table.Cell>
              <span className="text-body font-body text-subtext-color">
                {user.date_created
                  ? new Date(user.date_created).toLocaleDateString()
                  : "N/A"}
              </span>
            </Table.Cell>
            <Table.Cell>
              <div className="flex items-center gap-2">
                {onEdit && (
                  <Button
                    variant="neutral-tertiary"
                    size="small"
                    icon={<FeatherEdit />}
                    onClick={() => onEdit(user)}
                    disabled={loading}
                  >
                    Edit
                  </Button>
                )}
                {onDelete && (
                  <Button
                    variant="neutral-tertiary"
                    size="small"
                    icon={<FeatherTrash2 />}
                    onClick={() => onDelete(user.id)}
                    disabled={loading}
                  >
                    Delete
                  </Button>
                )}
              </div>
            </Table.Cell>
          </Table.Row>
        ))
      )}
    </Table>
  );
};
